// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mi-0";
export var buttonContainer = "_mi-3";
export var cancelButton = "_mi-4";
export var headerSection = "_mi-6";
export var headerTitle = "_mi-9";
export var messageSideLeft = "_mi-1";
export var messageSideRight = "_mi-2";
export var orderNumberContainer = "_mi-7";
export var orderNumberLabel = "_mi-8";
export var submitButton = "_mi-5";